import $http from '../../../utils/http';
export default (options) => {
  if (options.method === 'POST') {
    return $http({
      ...options,
      isPayload: true
    });
  }
  return $http(options);
};
